import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Result} from '@domain/common/http/result';
import {environment} from '@environments/environment';

/**
 * Service de gestion des relances
 */
@Injectable({providedIn: 'root'})
export class NotificationRelancesService {

    /**
     * Constructeur
     *
     * @param httpClient Service HTTP
     */
    constructor(private httpClient: HttpClient) {
    }

    /**
     * Chargement de l'écran détail d'une relance
     *
     * @param idRelance Identifiant de la relance (0 = création)
     */
    loadRelance(idRelance: number): Observable<Result> {
        return this.httpClient.post<Result>(`${environment.baseUrl}/controller/Relance/loadRelance/${idRelance}`,null);
    }

    /**
     * Enregistre la relance.
     *
     * @param relance Relance à sauvegarder
     */
    saveRelance(relance: any): Observable<Result> {
        return this.httpClient.post<Result>(`${environment.baseUrl}/controller/Relance/saveRelance`, relance);
    }


    /**
     * Exécute une relance pour un identifiant donné.
     *
     * @param idRelance identifiant de la relance à exécuter
     * @return résultat d’exécution
     */
    executeRelance(idRelance: number): Observable<Result> {
        return this.httpClient.post<Result>(`${environment.baseUrl}/controller/Relance/executeRelance/${idRelance}`,null);
    }

    /**
     * Supprime une relance.
     *
     * @param relance relance à supprimer
     * @return résultat de suppression
     */
    deleteRelance(relance: any): Observable<Result> {
        //Appel de la suppression d’une relance
        return this.httpClient.post<Result>(`${environment.baseUrl}/controller/Relance/deleteRelance`, relance);
    }
}